import { neon } from "@/integrations/neon";

export interface ParticipantInput {
  contactId?: string;
  email: string;
  name?: string | null;
}

export const syncParticipantsForScriptForm = async (
  scriptFormId: string,
  desiredParticipants: ParticipantInput[],
) => {
  return neon.api.participants.sync(scriptFormId, desiredParticipants);
};
